import { c as _c } from "react/compiler-runtime";
import { cx } from "@/lib/tailwind-utils";
import { useMessageContext } from "./message";
import { renderTextWithLinks } from "./shared";
interface MessageTextProps {
  children?: string | null;
  size?: "sm" | "lg";
}
export function MessageText(t0) {
  const $ = _c(8);
  const {
    children,
    size: t1
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const {
    isInbound
  } = useMessageContext();
  if (!children) {
    return null;
  }
  const t2 = size === "sm" ? "text-caption" : "text-body";
  let t3;
  if ($[0] !== t2) {
    t3 = cx(t2, "whitespace-pre-line");
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== isInbound) {
    t4 = renderTextWithLinks(children, {
      isPatient: isInbound
    });
    $[2] = children;
    $[3] = isInbound;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className={t3}>{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}